import { Suspense } from "react";
import { LoaderFunction, RouteObject } from "react-router-dom";
import { GeneralErrorPage } from "@songtradr-sso/shared/frontend";
import { LoadingSplash } from "@songtradr/design-language";
import { ConfirmPassword } from "./ConfirmPassword";
import {
  LoaderData,
  decryptEmail,
  routes,
  shouldRevalidate,
} from "./ConfirmPassword.Parts";

// LOADER
const ConfirmPasswordLoader: LoaderFunction = ({ request }): LoaderData => {
  const url = new URL(request.url);
  const searchParams = url.searchParams;

  const eml = searchParams.get("eml") ?? "";

  return { decryptEmail: decryptEmail(eml) };
};

// WRAPPER
const ConfirmPasswordWrapper = () => (
  <Suspense fallback={<LoadingSplash />}>
    <ConfirmPassword />
  </Suspense>
);

// ROUTE
export const ConfirmPasswordRouteObject: RouteObject = {
  path: routes.password.verifyCode,
  errorElement: <GeneralErrorPage />,
  Component: ConfirmPasswordWrapper,
  loader: ConfirmPasswordLoader,
  shouldRevalidate,
};
